<section  #quoteSection class="usa-section width-full padding-y-8 desktop:padding-y-15 padding-x-2 tablet:padding-x-8 display-flex flex-justify-center {{topTriangle}} {{bottomTriangle}} {{content?.elements?.['background_color']?.value?? 'bg-primary-dark'}}">
    <div  class="maxw-desktop-lg width-full display-flex flex-justify-center flex-column">
        <div [innerHTML]="safeQuoteHtml" class="remove-margin-from-immediate-children text-semibold">
        </div>
        <div *ngIf="this.content?.elements?.['attribution']?.value" class="sub-container display-flex flex-justify-end">
            <sub class="font-md" [innerHTML]="safeAttributionHtml"></sub>
        </div>
    </div>
</section>